






























































































































import {
  sensitiveWordDelete,
  sensitiveWordDownload,
  sensitiveWordQuery,
  sensitiveWordUpload,
  sensitiveActive
} from '@/service/data'
// import { getIllegalTypes } from '@/service/settings'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { Component, Vue, Watch, Prop, Mixins } from 'vue-property-decorator'
import { ConstantMixins } from './ConstantMixins'

@Component
export default class AllowList extends Mixins(ConstantMixins) {
  @Prop() public activeKey!: string
  // 国际化配置
  public localeZHCN = zhCN
  // search-data
  public searchParams = {
    word_name: '',
    sensitive_type: 0,
    begin_time: '',
    end_time: '',
    page_index: 1
  }
  // public sensitiveTypes = getIllegalTypes([0, '不限'])
  // operation-data
  public showUploadFileList = false
  public uploadUrl = sensitiveWordUpload
  // pagination-data
  public paginationData = {
    total: 0,
    current: 1,
    pageSize: 30,
    showTotal(total) {
      return `共 ${total} 条`
    },
    onChange: this.pageChange
  }
  // list-data
  public columnTitles = [
    {
      title: 'Id',
      dataIndex: 'id',
      width: '15%',
      key: 'id'
    },
    {
      title: '黑名单词',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: '类型',
      dataIndex: 'sensitive_type_text',
      key: 'sensitive_type_text'
    },
    {
      title: '添加人(审核员)',
      dataIndex: 'username',
      key: 'username'
    },
    {
      title: '入库时间',
      dataIndex: 'created_at',
      width: '20%',
      key: 'created_at'
    },
    {
      title: '操作',
      dataIndex: 'operation',
      width: '100px',
      align: 'center',
      scopedSlots: { customRender: 'operation' }
    }
  ]
  public selectedRowKeys = []
  public sensitiveWords = new Array<object>()
  /*
   * created
   */
  public created() {
    this.searchSensitiveWord(1)
  }
  /*
   * methods
   */
  // 日期选择
  public dateChoose(date, dateStrings) {
    this.searchParams.begin_time = dateStrings[0]
    this.searchParams.end_time = dateStrings[1]
  }
  // 敏感词查询
  public async searchSensitiveWord(page) {
    this.searchParams.page_index = page
    let response = await sensitiveWordQuery(this.searchParams)
    if (response.success) {
      this.sensitiveWords = response.data
      this.paginationData.pageSize = response.page_size
      this.paginationData.total = response.total
      this.paginationData.current = response.page_index
    }
  }
  // 页码变化
  public pageChange(page) {
    setTimeout(() => {
      this.selectedRowKeys = []
    }, 1000)
    this.searchSensitiveWord(page)
  }
  // 敏感词选择
  public onSelect(selectedRowKeys) {
    this.selectedRowKeys = selectedRowKeys
  }
  // 删除敏感词
  public async _deleteSensitiveWord() {
    let params = { word_ids: JSON.stringify(this.selectedRowKeys) }
    let response = await sensitiveWordDelete(params)
    if (response.success) {
      this.$message.success('删除成功')
      this.searchSensitiveWord(this.paginationData.current)
      this.selectedRowKeys = []
    }
  }
  public deleteSensitiveWord() {
    let that = this
    if (this.selectedRowKeys.length === 0) {
      return
    }
    this.$confirm({
      title: '删除',
      content: '是否从黑名单中删除？',
      okText: '确认',
      cancelText: '取消',
      onOk() {
        return that._deleteSensitiveWord()
      }
    })
  }
  // 导入敏感词
  public importSensitiveWord(info) {
    if (info.file.status === 'done') {
      if (info.file.response.success) {
        this.$message.success('导入文件成功')
        this.searchSensitiveWord(1)
      } else {
        this.$message.error(info.file.response.error)
      }
    } else if (info.file.status === 'error') {
      this.$message.error('导入文件失败')
    }
  }
  // 导出敏感词
  public exportSensitiveWord() {
    window.location.href = sensitiveWordDownload
  }
  public onWordNameChange() {
    if (this.searchParams.word_name === '') {
      this.searchSensitiveWord(1)
    }
  }
  // 切换tab刷新当前列表
  @Watch('activeKey')
  public onActiveKeyChange(val) {
    if (val === '1') {
      this.searchSensitiveWord(1)
    }
  }

  // 点击通过
  public clickPass(text, record) {
    console.log(text, record)
    console.log(record.id)
    // 请求后端接口
    this.senseActive([record.id])
  }

  public getPopupContainer() {
    return document.getElementById('sensitive-word')
  }

  // 通过请求
  public async senseActive(word_ids: string[] | number[]) {
    try {
      let data = await sensitiveActive({ word_ids })
      if (data.success) {
        // 刷新当前页面
        this.searchSensitiveWord(this.paginationData.current)
        this.selectedRowKeys = []
      }
    } catch (e) {
      console.log(e)
    }
  }

  // 批量通过
  public passSensitiveWord() {
    let word_ids = JSON.parse(JSON.stringify(this.selectedRowKeys))
    let that = this

    if (word_ids.length === 0) {
      return
    }
    this.$confirm({
      title: '通过确认',
      content: '',
      okText: '确认',
      cancelText: '取消',
      onOk() {
        return that.senseActive(word_ids)
      }
    })
  }
}
